import React, { useCallback, useState } from "react";
import SelectBox from "../../../components/SelectBox";
import useAppContext from "../../../utils/Reducers";

const SearchBar = (props) => {
  // SerachBar 기본 필드

  const {
    store: { userInfo },
  } = useAppContext();

  const handleChangeField = useCallback((event) => {
    const { name, value } = event.target;

    props.setSearchParameters({ ...props.primaryParameters, [name]: value });
  });

  return (
    <>
      <div className="searchdata">
        <ul>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 카메라명
            </div>
            <input
              type="text"
              className="datainput"
              name="schGroupNm"
              onChange={handleChangeField}
              value={props.searchParameters.schCameraNm}
            />
          </li>
          <li style={{ width: "350px" }}>
            <div className="divide50">
              <font color="grey">⦁</font> 하차지역
            </div>
            <SelectBox
              mastCd="SCRAP_AREA_CD"
              id="schScrapAreaCd"
              name="schScrapAreaCd"
              attr2="Y"
              topSelected="전체"
              onChange={handleChangeField}
              value={props.searchParameters.schScrapAreaCd}
              className="datainput"
              style={{ width: "250px" }}
            />
          </li>
        </ul>
      </div>
    </>
  );
};

export default React.memo(SearchBar);
